import { get } from 'lodash';
import {
  filterForActiveAdCvdCases,
  UsPrincipalAdCvdCaseType,
} from '../filterAdCvdCases';
import { HtsValues } from 'context/htsValues';

export const getAdCvdCases = (
  htsValues: HtsValues,
  countryOfOrigin: string,
) => {
  const allPrincipalAdCvdCases = get(
    htsValues.lineHTSObj,
    'principalAdCvdCases',
    [],
  );

  const adCases = filterForActiveAdCvdCases(allPrincipalAdCvdCases, {
    caseType: UsPrincipalAdCvdCaseType.AD,
    countryCode: countryOfOrigin,
  });
  const cvCases = filterForActiveAdCvdCases(allPrincipalAdCvdCases, {
    caseType: UsPrincipalAdCvdCaseType.CV,
    countryCode: countryOfOrigin,
  });

  return { adCases, cvCases };
};
